import { Injectable } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

const PAD_LENGTH = -2;
const DECIMAL_RADIX = 10;
const YEAR_ONLY_PARTS = 1;
const YEAR_MONTH_PARTS = 2;
const FULL_DATE_PARTS = 3;

function padNumber(value: number) {
    return `0${value}`.slice(PAD_LENGTH);
}

function isNumber(value: any): boolean {
    return !isNaN(toInteger(value));
}

function toInteger(value: any): number {
    return parseInt(`${value}`, DECIMAL_RADIX);
}

@Injectable()
 
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
    parse(value: string): NgbDateStruct {
        if (value) {
            const dateParts = value.trim().split('-');
            if (dateParts.length === YEAR_ONLY_PARTS && isNumber(dateParts[0])) {
                return {year: toInteger(dateParts[0]), month: null, day: null};
            } else if (dateParts.length === YEAR_MONTH_PARTS && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
                return {year: toInteger(dateParts[1]), month: toInteger(dateParts[0]), day: null};
            } else if (dateParts.length === FULL_DATE_PARTS && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
                return {year: toInteger(dateParts[2]), month: toInteger(dateParts[1]), day: toInteger(dateParts[0])};
            }
        }   
        return null;
    }

    format(date: NgbDateStruct): string {
        let stringDate: string = ""; 
        if(date) {
            stringDate += `${date.year}-` ;
            stringDate += isNumber(date.month) ? `${padNumber(date.month)}-` : "";
            stringDate += isNumber(date.day) ? padNumber(date.day)  : "";
          
        }
        return stringDate;
    }
}